// extracted by mini-css-extract-plugin
export default {"Contact":"contact_Contact__t3oim","contactInfo":"contact_contactInfo__GFzFa","address":"contact_address__2fVHE","phone":"contact_phone__PxcMK","email":"contact_email__O7CLr"};